const TABLE_PER_PAGE_STATE_KEY = 'table_per_page_state';

export function setTablePerPageState(tableId: string, perPage: number) {
  const tablePerPageState = localStorage.getItem(TABLE_PER_PAGE_STATE_KEY);
  const tablePerPageStateObject: Record<string, number> = tablePerPageState
    ? (JSON.parse(tablePerPageState) as Record<string, number>)
    : {};
  tablePerPageStateObject[tableId] = perPage;
  localStorage.setItem(TABLE_PER_PAGE_STATE_KEY, JSON.stringify(tablePerPageStateObject));
}

export function getTablePerPageState(tableId: string) {
  const tablePerPageState = localStorage.getItem(TABLE_PER_PAGE_STATE_KEY);
  const tablePerPageStateObject: Record<string, number> = tablePerPageState
    ? (JSON.parse(tablePerPageState) as Record<string, number>)
    : {};

  return tablePerPageStateObject[tableId];
}
